const commonEllipsisStyles = {
  display: '-webkit-box',
  boxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',  // for long "single word" line
};

const styles = (theme) => ({
  iconContainer: {
    display: 'flex',
    fontSize: 22,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius:24,
    background: '#EEF0F2',
    color: '#838A93',
    '& svg': {
      fill: '#838A93 !important'
    },

    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      width: 30,
      height: 30,
    },
  },
  namesContainer: {
    minWidth: 0,
    flexShrink: 1,
  },
  subCategoryName: {
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    ...commonEllipsisStyles,
    lineClamp: 2,
    '-webkit-line-clamp': 2,
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    }
  },
  assetName: {
    fontSize: 12,
    ...commonEllipsisStyles,
    lineClamp: 1,
    '-webkit-line-clamp': 1,
  }
});

export default styles;